var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconScreenShareStop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_stop_share",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .screen-share-stop-class-a {\n        fill: none !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_screen-share-stop"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    className: "screen-share-stop-class-a",
    "data-name": "Rectangle 15",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M23.333,22.209a2.429,2.429,0,0,0,2.322-2.518l.012-14.173A2.43,2.43,0,0,0,23.333,3H4.667A2.423,2.423,0,0,0,2.333,5.518V19.691a2.43,2.43,0,0,0,2.333,2.518H0v2.518H28V22.209ZM4.667,19.691V5.518H23.333V19.7Z",
    transform: "translate(2 2)",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phonelink_erase_FILL0_wght400_GRAD0_opsz48",
    d: "M27.791,24.983,26.6,23.792l3.176-3.176L26.6,17.441l1.191-1.191,3.176,3.176,3.176-3.176,1.191,1.191-3.176,3.176,3.176,3.176-1.191,1.191-3.176-3.176Z",
    transform: "translate(-14.966 -5.836)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconScreenShareStop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_screen_share_stop.d39d7ac5ef47d7d24b797a5f3713b2bc.svg";